import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { APP_ENV } from '../config';
import auth, { AuthState } from './auth';
import versions, { VersionsState } from './versions';

export type RootState = Readonly<{
  auth: AuthState;
  versions: VersionsState;
}>;

// eslint-disable-next-line no-console
console.log(`Persisting HUB reducers for ${APP_ENV}`);
const persistConfig = {
  debug: APP_ENV === 'dev',
  keyPrefix: `hub-${APP_ENV}-`,
  storage,
} as const;

const reducers = combineReducers({
  auth: persistReducer({ key: 'auth', ...persistConfig }, auth),
  versions: persistReducer({ key: 'versions', ...persistConfig }, versions),
});

export default reducers;
